import clsx from "clsx";
import React from "react";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Button, IconButton, Tooltip } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import InputAdornment from "@material-ui/core/InputAdornment";
import DateFnsUtils from "@date-io/date-fns";
import { FaUndo } from "react-icons/fa";

export function BulkEditDatePickerCustom({
  className,
  classes,
  name,
  arialabel,
  variant,
  format,
  margin,
  minDate,
  autoOk,
  value,
  inputProps,
  disabled,
  onChange,
  clearValueButton,
  onClearValueEvent,
  yearView,
  title,
  titleClass,
  refreshDisabled,
  refreshOnClick,
}) {
  return (
    <>
      <label className={classes.globalCreateLabel} htmlFor={title}>
        {title}
      </label>
      <span>:</span>

      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            //className={clsx(classes, classes.tableFilterInput, classes.tableFilterDate, classes.tableFilterDateInput)}
            disabled={disabled}
            className={className}
            name={name}
            aria-label={arialabel}
            variant={variant}
            format={format}
            margin={margin}
            minDate={minDate}
            value={value}
            autoOk={autoOk}
            inputProps={inputProps}
            onChange={(event) => {
              if (onChange) {
                onChange(event);
              }
            }}
            views={yearView ? ["year"] : undefined} // Display only the year
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {clearValueButton && (
                    <>
                      <div className={classes.globalClearButton}>
                        <IconButton
                          title="Clear value"
                          aria-label="Clear value"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (onClearValueEvent) {
                              onClearValueEvent(e);
                            }
                          }}>
                          <ClearIcon />
                        </IconButton>
                      </div>
                    </>
                  )}
                </InputAdornment>
              ),
            }}
          />
        </MuiPickersUtilsProvider>
        {!refreshDisabled && (
          <Tooltip title={"Reset to default value"}>
            <Button
              aria-label={name}
              id={name}
              name={name}
              disabled={refreshDisabled}
              onClick={refreshOnClick}
              className={classes.resetButton}>
              <FaUndo style={{ fontSize: "10px" }} />
            </Button>
          </Tooltip>
        )}
      </div>
    </>
  );
}
